export default __webpack_public_path__ + "static/flyer@2x-4ed10dca75a51db0f1a984ea45c770cb.jpg";